import React from "react";

const Threshold360 = ({
	id,
	title,
}) => {
	return (
		<iframe
			title={`Threshold360 Viewer for ${title || id}`}
			className="threshold360-iframe__responsive"
			src={`https://viewer.threshold360.com/?thresholdId=${id}`}
			frameBorder="0"
			allowFullScreen
		></iframe>
	)
}

export default Threshold360;